import React from "react";
import logo from "../../assets/img/AvoConsulte-Logo.svg";

export default function MobileHeader() {
  return (
    <div className="navbar-header">
      <div
        style={{
          marginTop: "80px",
          marginBottom: "60px",
          marginLeft: "40px",
          marginRight: "40px",
        }}>
        <img src={logo} className="img-fluid" alt="Logo" />
      </div>
    </div>
  );
}
